type DialogTitleProps = Readonly<{
  children: string;
}>;

const DialogTitle = ({ children }: DialogTitleProps) => {
  return <h1 className='p-6 text-gray-900 text-headline-3'>{children}</h1>;
};

export default DialogTitle;
